import React, { useCallback, useMemo, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { DialogActions } from "@mui/material";
import { PrimaryButton } from "components/mui-styled-components/Buttons";
import GradientGhostButton from "components/Buttons/GradientGhostButton";
import { RightCaretFilled, LeftCaretFilled, DownCaretFilled, CloseIcon } from "components/Icons";
import { cvar } from "styles";
import DateTimeToolbar, { DateTimeToolbarContext } from "./DateTimeToolbar";
import * as S from "./styles";

export type StaticDateTimePickerT = {
  handleSave: (selectedTimeStamp: string) => void;
  onClose: () => void;
  hideTime?: boolean;
  dateFormat?: string;
  toolbarLabel?: string | null;
};

const StaticDateTimePicker = ({
  handleSave,
  onClose,
  hideTime = false,
  dateFormat = "YYYY-MM-DD HH:mm:ss",
  toolbarLabel = null,
}: StaticDateTimePickerT) => {
  const [dateTimeValue, setDateTimeValue] = useState<string>(dayjs().toString());

  const handleDateChange = (newDate: unknown): void => {
    setDateTimeValue((prev) =>
      dayjs(newDate as Dayjs)
        .hour(dayjs(prev).hour())
        .minute(dayjs(prev).minute())
        .toString(),
    );
  };

  const handleTimeChange = useCallback((hrs: number, mins: number) => {
    setDateTimeValue((prev) => dayjs(prev).hour(hrs).minute(mins).toString());
  }, []);

  const handleDateTimeSelect = () => {
    handleSave(dayjs(dateTimeValue).second(0).format(dateFormat));
    onClose();
  };

  const toolbarContext = useMemo(
    () => ({ value: dateTimeValue, hideTime, label: toolbarLabel, onTimeChange: handleTimeChange }),
    [dateTimeValue, hideTime, toolbarLabel, handleTimeChange],
  );

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimeToolbarContext.Provider value={toolbarContext}>
          <S.StyledDatePicker
            value={dateTimeValue}
            onChange={handleDateChange}
            disableHighlightToday
            renderInput={() => <></>}
            components={{
              RightArrowIcon: RightCaretFilled,
              LeftArrowIcon: LeftCaretFilled,
              SwitchViewIcon: DownCaretFilled,
            }}
            componentsProps={{
              actionBar: { actions: [] },
            }}
            showToolbar
            ToolbarComponent={DateTimeToolbar}
          />
        </DateTimeToolbarContext.Provider>
      </LocalizationProvider>
      <DialogActions
        sx={{
          justifyContent: "center",
          padding: "14px 22px",
          background: cvar("dark-blue-a07"),
        }}
      >
        <GradientGhostButton onClick={onClose} style={{ marginRight: "7px" }}>
          <CloseIcon startFill={cvar("picton-blue")} stopFill={cvar("blue-ribbon")} />
        </GradientGhostButton>
        <PrimaryButton
          onClick={handleDateTimeSelect}
          gradient
          style={{ minWidth: "164px", height: "32px", padding: "8px 24px" }}
        >
          Save
        </PrimaryButton>
      </DialogActions>
    </>
  );
};

export default StaticDateTimePicker;
